/* src/app/academy/academy.component.css */
.template {
  margin-left: 5rem;
  margin-right: 5rem;
  margin-top: 2rem;
  margin-bottom: 2rem;
  font-size: xx-large;
}
.pText {
  font-size: large;
}
.box {
  display: flex;
  background-color: white;
}
@media (max-width: 767px), screen and (max-width: 812px) and (orientation: landscape) {
  .box {
    display: block;
  }
}
img {
  max-height: 200px;
  max-width: 240px;
}
@media (max-width: 767px), screen and (max-width: 812px) and (orientation: landscape) {
  img {
    max-height: fit-content;
    max-width: fit-content;
  }
}
.col {
  max-width: max-content;
}
.width {
  max-width: 60rem;
}
.hero__play {
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(94, 206, 66, 0.8);
  width: 9.4rem;
  height: 9.4rem;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 7rem;
  margin-top: 2rem;
}
@media (max-width: 767px), screen and (max-width: 812px) and (orientation: landscape) {
  .hero__play {
    top: 11.8rem;
    margin-top: -3rem;
    transform: translateX(-50%);
    width: 6rem;
    height: 6rem;
  }
}
.hero__play img {
  max-width: 1rem;
}
::ng-deep .windowSize .modal-dialog {
  max-width: max-content;
}
@media (max-width: 767px), screen and (max-width: 812px) and (orientation: landscape) {
  ::ng-deep .windowSize .modal-dialog {
    max-width: max-content;
  }
}
.carousel-wrapper {
  width: 100%;
  height: fit-content;
}
.carousel {
  display: inline-flex;
  width: 100%;
  height: 40%;
  margin-left: auto;
  margin-right: auto;
  border-radius: 16px;
}
.carousel.x {
  overflow-x: auto;
}
.carousel.y {
  overflow-y: auto;
  flex-direction: column;
}
.carousel.x li:not(:first-of-type) {
  margin-left: 5%;
}
.carousel.y li:not(:first-of-type) {
  border-top: dashed 1px red;
}
.carousel img {
  width: 100%;
  height: 100%;
}
.carousel li {
  display: flex;
  min-width: 100%;
  min-height: 100%;
  background-color: #e5e5e5;
  justify-content: center;
  box-sizing: content-box;
  align-items: center;
}
.position {
  text-align: center;
}
.position .dot {
  background-color: #dad5d5;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: inline-block;
}
.position .dot:not(:first-of-type) {
  margin-left: 0.5em;
}
.position .active {
  background-color: #00BCD4;
}
.carousel.y.mandatory {
  scroll-snap-type: y mandatory;
}
.carousel.x.mandatory {
  scroll-snap-type: x mandatory;
}
.carousel.y.proximity {
  scroll-snap-type: y proximity;
}
.carousel.x.proximity {
  scroll-snap-type: x proximity;
}
.carousel li {
  scroll-snap-align: center;
}
.carouselItem {
  height: 75%;
  width: 100%;
  box-shadow: 0px 2px 4px rgb(0 0 0 / 8%);
  border-radius: 16px;
  margin-top: 10%;
  margin-bottom: 13%;
}
.bg-white {
  background-color: white;
  margin-top: 3%;
  margin-bottom: 3%;
}
.cardItem {
  background-color: white;
}
/*# sourceMappingURL=academy.component.css.map */
